import React from 'react';

function Skills() {
  return (
    <div className="my-skills2">
      <div className="container">
        <div className="sec-head text-center mb-80">
          <h6 className="sub-title main-color mb-15">Our Portfolio</h6>
          <h2>
            Our featured <span className="fw-200">projects</span>
          </h2>
        </div>
        <div className="row md-marg">
          <div className="col-lg-2 col-md-4 col-6">
            <div className="item mb-30">
              <div className="box-bord main-bg">
                <div className="img">
                  <img src="/dark/assets/imgs/resume/s1.png" alt="" />
                </div>
                <span className="value">95%</span>
              </div>
              <h6 className="fz-18">UI / UX Design</h6>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6">
            <div className="item mb-30">
              <div className="box-bord main-bg">
                <div className="img">
                  <img src="/dark/assets/imgs/resume/s2.png" alt="" />
                </div>
                <span className="value">90%</span>
              </div>
              <h6 className="fz-18">Development</h6>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6">
            <div className="item mb-30">
              <div className="box-bord main-bg">
                <div className="img">
                  <img src="/dark/assets/imgs/resume/s3.png" alt="" />
                </div>
                <span className="value">85%</span>
              </div>
              <h6 className="fz-18">Graphic Design</h6>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6">
            <div className="item mb-30">
              <div className="box-bord main-bg">
                <div className="img">
                  <img src="/dark/assets/imgs/resume/s5.png" alt="" />
                </div>
                <span className="value">84%</span>
              </div>
              <h6 className="fz-18">Sketch</h6>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6">
            <div className="item mb-30">
              <div className="box-bord main-bg">
                <div className="img">
                  <img src="/dark/assets/imgs/resume/s4.png" alt="" />
                </div>
                <span className="value">78%</span>
              </div>
              <h6 className="fz-18">WordPress</h6>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6">
            <div className="item mb-30">
              <div className="box-bord main-bg">
                <div className="img">
                  <img src="/dark/assets/imgs/resume/s6.png" alt="" />
                </div>
                <span className="value">85%</span>
              </div>
              <h6 className="fz-18">Graphic Design</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skills;
